var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1.75C0 0.783502 0.783502 0 1.75 0H5.25C6.2165 0 7 0.783502 7 1.75V5.25C7 6.2165 6.2165 7 5.25 7H1.75C0.783502 7 0 6.2165 0 5.25V1.75ZM1.75 1.5C1.61193 1.5 1.5 1.61193 1.5 1.75V5.25C1.5 5.38807 1.61193 5.5 1.75 5.5H5.25C5.38807 5.5 5.5 5.38807 5.5 5.25V1.75C5.5 1.61193 5.38807 1.5 5.25 1.5H1.75ZM9 1.75C9 0.783502 9.7835 0 10.75 0H14.25C15.2165 0 16 0.783502 16 1.75V5.25C16 6.2165 15.2165 7 14.25 7H10.75C9.7835 7 9 6.2165 9 5.25V1.75ZM10.75 1.5C10.6119 1.5 10.5 1.61193 10.5 1.75V5.25C10.5 5.38807 10.6119 5.5 10.75 5.5H14.25C14.3881 5.5 14.5 5.38807 14.5 5.25V1.75C14.5 1.61193 14.3881 1.5 14.25 1.5H10.75ZM0 10.75C0 9.7835 0.783502 9 1.75 9H5.25C6.2165 9 7 9.7835 7 10.75V14.25C7 15.2165 6.2165 16 5.25 16H1.75C0.783502 16 0 15.2165 0 14.25V10.75ZM1.75 10.5C1.61193 10.5 1.5 10.6119 1.5 10.75V14.25C1.5 14.3881 1.61193 14.5 1.75 14.5H5.25C5.38807 14.5 5.5 14.3881 5.5 14.25V10.75C5.5 10.6119 5.38807 10.5 5.25 10.5H1.75ZM9 10.75C9 9.7835 9.7835 9 10.75 9H14.25C15.2165 9 16 9.7835 16 10.75V14.25C16 15.2165 15.2165 16 14.25 16H10.75C9.7835 16 9 15.2165 9 14.25V10.75ZM10.75 10.5C10.6119 10.5 10.5 10.6119 10.5 10.75V14.25C10.5 14.3881 10.6119 14.5 10.75 14.5H14.25C14.3881 14.5 14.5 14.3881 14.5 14.25V10.75C14.5 10.6119 14.3881 10.5 14.25 10.5H10.75Z",
    fill: "#9E9FA1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboardIcon.6975a0a417fef0ef41cf908245068775.svg";
export { ForwardRef as ReactComponent };